import { render, staticRenderFns } from "./Foo.vue?vue&type=template&id=d5dcb454&"
import script from "./Foo.vue?vue&type=script&lang=js&"
export * from "./Foo.vue?vue&type=script&lang=js&"
import style0 from "./Foo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports